import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import HeaderView from '@/components/HeaderView.vue';
import MobileHeader from '@/components/mobile/HeaderView.vue';
import BottomNavigation from '@/components/BottomNavigation.vue';
import { pathTable } from '@/config'
import ContactUs from '@/components/ContactUs.vue'
import MobileBottomNavigation from '@/components/mobile/BottomNavigation.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter()
const store = useStore()
const hideTitle = ref(false)
// 需要缓存的组件名称列表，与组件的 name 属性对应
// 只有在这里列出的组件才会被 keep-alive 缓存
const keepAliveComponents = ['SolutionView', 'MobileSolution']


const changePath = (path: string) => {
  console.log(path)
}

// 路由拦截，这里主要根据路由确定一些组件的显隐性
router.beforeEach((to, from, next) => {
  hideTitle.value = Boolean((to.meta && to.meta.hideTitle));
  const pathInfo = JSON.stringify({ query: to.query || {} })
  window.sessionStorage.setItem('path', pathInfo)
  const pathName = to.name || ''
  store.state.titleIndex = pathTable[pathName]
  store.state.isBlankBg = pathName
  
  // 检查是否有保持滚动位置的标记
  const keepScrollPosition = window.sessionStorage.getItem('keepScrollPosition');
  
  // 如果有标记或目标页面是缓存页面，不滚动到顶部
  if (!keepScrollPosition && !to.meta.keepAlive) {
    window.scrollTo(0, 0)
  }
  
  // 清除标记，下次导航时恢复默认行为
  if (keepScrollPosition) {
    window.sessionStorage.removeItem('keepScrollPosition');
  }
  
  next();
});

onMounted(() => {
  setRem()
  window.addEventListener('resize', () => {
    setRem()
  }, false)
  // 判断是不是移动端
})

const setRem = () => {
  let rootDom: any = document.querySelector('html');
  let rootWidth = document.documentElement.clientWidth || document.body.clientWidth;

  var userAgent = navigator.userAgent.toLowerCase();
  if (
    userAgent.match(
      /(phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone|windows mobile|windows ce|ucweb|rv:1.2.3.4|midp)/i
    )
  ) {
    rootDom.style.fontSize = rootWidth / 750 + 'px';
    store.state.userAgent = 'mobile'
  } else {
    rootDom.style.fontSize = Math.min(Math.max(rootWidth / 1920, 0.2), 3) + 'px';
    store.state.userAgent = 'pc'
  }

}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(store).state.userAgent == 'pc')
      ? (_openBlock(), _createBlock(HeaderView, {
          key: 0,
          "change-path": changePath,
          hideTitle: hideTitle.value
        }, null, 8, ["hideTitle"]))
      : _createCommentVNode("", true),
    (_unref(store).state.userAgent == 'mobile')
      ? (_openBlock(), _createBlock(MobileHeader, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["router-wrap", _unref(store).state.userAgent == 'pc' ? 'web-wrap' : 'mobile-wrap'])
    }, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, { include: keepAliveComponents }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ], 1024))
        ]),
        _: 1
      }),
      (_unref(store).state.userAgent == 'pc')
        ? (_openBlock(), _createBlock(BottomNavigation, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(store).state.userAgent == 'mobile')
        ? (_openBlock(), _createBlock(MobileBottomNavigation, { key: 1 }))
        : _createCommentVNode("", true)
    ], 2),
    (_unref(store).state.userAgent == 'pc')
      ? (_openBlock(), _createBlock(ContactUs, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})